<section>
  <div class="row g-3">
    <div class="col-xl-8 col-12">
      <div class="sana-card">
        <a
          class="back-hint"
          role="link"
          [routerLink]="['../..']"
          tabindex="0">
          <i class="pi pi-chevron-left"></i> Zurück zum Start
        </a>

        <div class="sana-card-header">
          <span>Therapiepläne von {{ selectedClient().fullNameWithTitle }}</span>
        </div>

        <sana-tp-client-therapy-plan-list
          [therapyPlans]="therapyPlans()"
          [clientId]="selectedClient().id!">
        </sana-tp-client-therapy-plan-list>

        <div class="mt-3">
          <p-button
            class="d-flex justify-content-end"
            (onClick)="routeToNewTherapyPlan()"
            severity="primary"
            size="small"
            [label]="therapyPlans().length === 0 ? 'Therapieplan erstellen' : 'Therapieplan hinzufügen'"
            icon="pi pi-plus"
            data-cy="sana-tp-client-therapy-plan-create" />
        </div>
      </div>
    </div>

    <div class="col-xl-4 col-12">
      <div class="sana-card">
        <div class="sana-card-header">
          <span data-cy="sana-tp-client-details-header">Details zu {{ selectedClient().fullNameWithTitle }}</span>
        </div>

        <div class="sana-card-body">
          <div class="row g-3">
            <div class="col-12 with-icon">
              <span>
                <i class="pi pi-envelope"></i>
              </span>

              <span><a
                [href]="'mailto:' + selectedClient().email"
                data-cy="sana-tp-client-details-email">{{ selectedClient().email }}</a></span>
            </div>

            @if (selectedClient().phoneNumber) {
              <div class="col-12 with-icon">
                <span>
                  <i class="pi pi-phone"></i>
                </span>

                <span><a
                  [href]="'tel:' + selectedClient().phoneNumber"
                  data-cy="sana-tp-client-details-phone">{{ selectedClient().phoneNumber }}</a></span>
              </div>
            }

            <div class="col-12 with-icon">
              <span>
                <i class="pi pi-calendar"></i>
              </span>

              <span data-cy="sana-tp-client-details-dateOfBirth">{{ selectedClient().dateOfBirth | date:'dd.MM.yyyy' }}</span>
            </div>

            <div class="col-12 with-icon">
              <span>
                <i class="pi pi-id-card"></i>
              </span>

              <span data-cy="sana-tp-client-details-svnr">{{ selectedClient().socialSecurityNumber }}</span>
            </div>

            @if (selectedClient().isRegisteredInApp) {
              <span class="col-12 mt-3">
                <small
                  class="text-muted"
                  data-cy="sana-tp-client-details-registeredInAppAt">Seit {{ selectedClient().registeredInAppAt | date:'dd.MM.yyyy' }} in der App aktiv.</small>
              </span>
            } @else {
              <div class="col-12">
                <p-button
                  label="App Einladung erneut senden"
                  icon="pi pi-at"
                  severity="secondary"
                  (onClick)="sendAppInvite()"
                  [loading]="isInviteSending"
                  [fluid]="true"></p-button>
              </div>
            }

            @if (selectedClient().activeDiagnoses.length !== 0) {
              <div class="col-12">
                <div class="diagnosis-wrapper">
                  <hr />
                  @for (diagnosis of selectedClient().activeDiagnoses; track diagnosis.id; ) {
                    <p-badge
                      [value]="diagnosis.title"
                      severity="secondary"
                    ></p-badge>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
